import React, { Component } from "react";
import { DATA_TYPE, MAX_LENGTH } from "../../../../../constants/external-constants";
import { InputFieldFloatingLabel as InputField } from "../../../../common/custom-form/select-filter.component";
import DATEPICKER_OR from '../../../../common/custom-form/custom-date-picker.component'
class Swisscom extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: null
        }
    }

    render() {

        return (
            <>
                <InputField
                    className="form-control"
                    type="text"
                    label={this.props.InvoiceLabel}
                    value={this.props.invoiceNumber}
                    fieldProp='invoiceUploadForm.invoiceNumber'
                    maxLength={MAX_LENGTH.limit_255}
                    placeholder={this.props.placeholderInvoiceNumber}
                    requiredField={true}
                />

                <DATEPICKER_OR
                    dateOnly={true}
                    label={this.props.Datelabel}
                    startDate={this.props.startDate ? this.props.startDate : this.state.startDate}
                    selectedDate={(date) => this.props.selectedDate(date)}
                    placeholder={this.props.placeholder}
                    requiredField={true}
                />


            </>
        )
    }
}

export default Swisscom;